import { useState } from 'react'
import { useAuth } from '../auth/useAuth'
import { useLang } from '../i18n/LangProvider'
import { t } from '../catalogo/i18n'
import { PageTopbar } from '../styles/PageTopbar'
import { EmptyState } from '../styles/EmptyState'
import { seccionesPara } from './manual'
import styles from './ManualPage.module.css'

function normalizar(texto: string): string {
  return texto.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()
}

// Petición del club (2026-10-31): "un manual de usuario accesible desde la propia app, porque hay
// bastante funcionalidad". Secciones plegables según el rol, en el idioma elegido, con buscador: al
// buscar se abren las secciones que coinciden y solo se ven los puntos que contienen el texto.
export function ManualPage() {
  const { user } = useAuth()
  const lang = useLang()
  const [busqueda, setBusqueda] = useState('')
  const consulta = normalizar(busqueda.trim())

  const secciones = seccionesPara(user?.roles)
    .map((s) => ({
      ...s,
      puntos: consulta
        ? normalizar(s.titulo[lang]).includes(consulta)
          ? s.puntos
          : s.puntos.filter((p) => normalizar(p[lang]).includes(consulta))
        : s.puntos,
    }))
    .filter((s) => s.puntos.length > 0)

  return (
    <div>
      <PageTopbar />
      <main className={styles.page}>
        <h2>{t('manualTitulo', lang)}</h2>
        <p className={styles.intro}>{t('manualIntro', lang)}</p>
        <input
          type="search"
          className={styles.buscar}
          placeholder={t('buscarManual', lang)}
          aria-label={t('buscarManual', lang)}
          value={busqueda}
          onChange={(e) => setBusqueda(e.target.value)}
        />
        {secciones.length === 0 && <EmptyState text={t('manualSinResultados', lang)} icon="🔍" />}
        {secciones.map((s) => (
          // `key` con la consulta: al buscar se vuelven a montar abiertas; sin búsqueda, cerradas.
          <details key={`${s.id}-${consulta}`} id={s.id} className={styles.seccion} open={!!consulta}>
            <summary>
              <span aria-hidden className={styles.icono}>
                {s.icono}
              </span>
              {s.titulo[lang]}
            </summary>
            <ul>
              {s.puntos.map((p) => (
                <li key={p.es}>{p[lang]}</li>
              ))}
            </ul>
          </details>
        ))}
      </main>
    </div>
  )
}
